<nb-card>
  <nb-card-header>
    <span>Últimas vendas</span>
  </nb-card-header>
  <ngx-latest-sales-card [cardData]="transactionsData"></ngx-latest-sales-card>
</nb-card>